// import Vue from "vue";
import { createRouter, createWebHistory } from "vue-router";
import store from "../store/index";
import bug from "../views/general/reportABug/ReportABug.vue";
import suggestions from "../views/general/suggestions/Suggestions.vue";
import dataAccessRequest from "../views/general/dataAccessRequest/DataAccessRequest.vue";

// Vue.use(Router);
const lazyLoad = (view) => {
  return () => import(`@/views/${view}.vue`);
};

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: lazyLoad("general/login/Login"),
      beforeEnter: (to, from, next) => {
        if (store.state.user.isAuthenticated) next({ name: "home" });
        else next();
      },
    },
    {
      path: "/penpic",
      name: "PenPicView",
      component: lazyLoad("candidates/PenPic/PenPicView"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("UPPG")) {
          next();
        } else if (store.getters.currentUser.penpic_completed) {
          next();
        } else {
          next({ name: "Edit Details" });
        }
      },
    },
    {
      path: "/penpic/edit-details",
      name: "Edit Details",
      component: lazyLoad("candidates/editDetails/EditDetails"),
    },
    {
      path: "/feedback",
      name: "feedback",
      component: lazyLoad("general/feedback/Feedback"),
    },
    {
      path: "/suggestions",
      name: "suggestions",
      component: suggestions,
    },
    {
      path: "/data-access-request",
      name: "data-access-request",
      component: dataAccessRequest,
    },
    {
      path: "/bug",
      name: "bug",
      component: bug,
    },
    {
      path: "/",
      name: "home",
      component: lazyLoad("general/HomePage"),
      beforeEnter: (to, from, next) => {
        if (
          !store.getters.currentUser &&
          !store.getters.currentUser?.privacy_approval
        ) {
          next({ name: "policy_approval" });
        } else if (store.getters.userHasRole(["Super Administrator"])) {
          next();
        } else if (!store.getters.currentUser.penpic_completed) {
          next({ name: "Edit Details" });
        } else if (store.getters.userHasRole("Candidate")) {
          next({ name: "PenPicView" });
        } else {
          next();
        }
      },
    },
    {
      path: "/search",
      name: "search",
      component: lazyLoad("candidates/candidateFilter/CandidateFilter"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("UPPF")) {
          next();
        } else {
          next({ name: "home" });
        }
      },
    },
    {
      path: "/policy_approval",
      name: "policy_approval",
      component: lazyLoad("PolicyApproval"),
      beforeEnter: (to, from, next) => {
        if (!store.getters?.currentUser?.privacy_approval) {
          next();
        } else {
          next({ name: "home" });
        }
      },
    },

    {
      path: "/insights",
      name: "Insights",
      component: lazyLoad("insights/InsightsDashboard"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("ANL")) next();
        else next({ name: "PenPicView" });
      },
    },

    // {
    //   path: "/reporting",
    //   name: "Reporting",
    //   component: lazyLoad("insights/reporting/Reporting"),
    //   beforeEnter: (to, from, next) => {
    //     if (store.getters.userHasPerm("ANL")) next();
    //     else next({ name: "PenPicView" });
    //   },
    // },

    {
      path: "/resourcing",
      name: "Resourcing",
      component: lazyLoad("resourceManagement/RMLandingPage"),
    },
    {
      path: "/resourcing/resources",
      name: "Resources",
      component: lazyLoad("resourceManagement/Resources/Resources"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("URF")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/resourcing/tsc",
      name: "TSC",
      component: lazyLoad("resourceManagement/Tsc/TSC"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("TSCF")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/engagements",
      name: "Engagements",
      component: lazyLoad("resourceManagement/EngagementsLandingPage"),
    },
    {
      path: "/engagements/users",
      name: "Users",
      component: lazyLoad("resourceManagement/Users/Users"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("URF")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/engagements/open-seats",
      name: "Open Seats",
      component: lazyLoad("resourceManagement/OpenSeats/OpenSeats"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("OSF")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/engagements/projects",
      name: "Projects",
      component: lazyLoad("resourceManagement/Projects/Projects"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("PROF")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/engagements/candidates",
      name: "Candidates",
      component: lazyLoad("resourceManagement/Candidates/Candidates"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("OSF")) next();
        else next({ name: "home" });
      },
    },

    // {
    //   path: "/insights/map",
    //   name: "Map",
    //   component: lazyLoad("insights/insightsTabs/Map"),
    //   beforeEnter: (to, from, next) => {
    //     if (store.getters.userHasPerm("ANL")) next();
    //     else next({ name: "home" });
    //   },
    // },
    {
      path: "/admin",
      alias: "/admin/settings",
      name: "SettingsLandingPage",
      component: lazyLoad("admin/SettingsLandingPage"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm(["AA", "ABF", "RMC", "AURM"])) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/admin/settings/support",
      name: "Support",
      component: lazyLoad("admin/Support"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("ABF")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/admin/settings/application-configuration",
      name: "AppConfig",
      component: lazyLoad("admin/Settings"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("AA")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/admin/settings/resource-management",
      name: "Configuration",
      component: lazyLoad("admin/Settings"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("RMC")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/admin/settings/role-management",
      name: "UserRoleManagement",
      component: lazyLoad("admin/Settings"),
      beforeEnter: (to, from, next) => {
        if (store.getters.userHasPerm("AURM")) next();
        else next({ name: "home" });
      },
    },
    {
      path: "/:catchAll(.*)",
      component: lazyLoad("general/notFound/NotFound"),
    },
  ],
});

export default router;
